import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=2238d168&scoped=true"
import script from "./my-account.vue?vue&type=script&lang=js"
export * from "./my-account.vue?vue&type=script&lang=js"
import style0 from "./my-account.vue?vue&type=style&index=0&id=2238d168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2238d168",
  null
  
)

export default component.exports